// Dependencies
import { h, Component } from "preact";


import dayjs from "lib/helpers/dayjs";

// Components
import { TimeSlotColumn } from "components/groups";
import {
	Row,
	Col,
	Container,
	SquareImage,
	I18n,
} from "components/elements";
import LoadingIcon from "components/elements/LoadingIcon";

// Actions
import { WaitListActions } from "actions";

// Helpers
import { times } from "lib/helpers";

// Styles
import style from "./style";

// Icons
import chevronDown from "../../../assets/icons/svg/chevron_down.svg";
import providerImage from "../../../assets/icons/svg/provider_image.svg";

// Global Constant
const Fragment = h.Fragment;

// Class Component
export default class TimeSlotsCard extends Component {
	// Constructor
	constructor() {
		super();
		this.state = {
			expanded: false,
		};
		this.handleShowMore = this.handleShowMore.bind(this);
		this.destroyFromWaitlist = this.destroyFromWaitlist.bind(this);
		this.addToWaitlists = this.addToWaitlists.bind(this);
	}

	// Hook Methods
	componentWillReceiveProps(nextProps) {
		if (!nextProps.startDate.isSame(this.props.startDate)) {
			this.setState({ expanded: false });
		}
	}

	componentDidMount() {
		this.fetch();
	}

	// Getters
	get appointmentType() {
		return (
			this.props.appointmentTypes[this.props.filters.appointmentTypeID] || {}
		);
	}

	get hasRestrictions() {
		return (this.appointmentType.rules || []).length > 0;
	}

	get moreTimeSlots() {
		return this.timeSlotsData.moreTimeSlots;
	}

	get hasTimeSlots() {
		for (let data of this.timeSlotsData.timeSlots) {
			if (data.length) {
				return true;
			}
		}
		return false;
	}

	get timeSlots() {
		return this.timeSlotsData.timeSlots;
	}

	get timeSlotsData() {
		let timeSlots = times(1).map((i) => {
			let filterDate = this.props.startDate
				.clone()
				.add(i, "days")
				.format("MM/DD/YYYY");
			let timeSlots = this.props.timeSlots
				.filter((ts) => {
					return dayjs(ts.startsAt).format("MM/DD/YYYY") == filterDate;
				})
				.sort((a, b) => {
					if (dayjs(a.startsAt).isBefore(dayjs(b.startsAt))) return -1;
					if (dayjs(a.startsAt).isAfter(dayjs(b.startsAt))) return 1;
					return 0;
				});

			return timeSlots;
		});

		return { timeSlots, moreTimeSlots: timeSlots[0].length > 6};
	}

	get hasMoreAvailabilites() {
		if (
			this.props.outOfSlots ||
			dayjs(this.props.startDate).isAfter(dayjs().add(6, "months"))
		) {
			return false;
		}
		return true;
	}

	get showAddToQueue() {
		if (this.waitlistItem) {
			return true;
		}
		return false;
	}

	get account() {
		return this.props.session.account;
	}

	get waitListActivated() {
		return _.get(this, "props.organization.settings.waitList");
	}

	get waitlistItem() {
		return Object.values(this.props.waitLists || []).filter(
			(_waitList) =>
				_waitList.appointmentTypeID == this.appointmentType.id &&
				_waitList.administratorID == this.props.id
		)[0];
	}
	
	get name() {
		return (
			this.props.name ||
			`${this.props.firstName || ""} ${this.props.lastName || ""}`
		);
	}


	// Methods
	addToWaitlists() {
		let accountID = this.account.id;
		let appointmentTypeID = this.appointmentType.id;
		return WaitListActions.create({
			administratorID: this.props.id,
			accountID,
			appointmentTypeID,
		}).then(() => {
			this.fetch();
		});
	}

	fetch() {
		let accountID = this.account.id;
		let appointmentTypeID = this.appointmentType.id; 
		return WaitListActions.fetch({
			accountID,
			appointmentTypeID,
		});
	}

	destroyFromWaitlist(id) {
		return WaitListActions.destroy({ id }).then((res) => {
			this.fetch();
		});
	}


	handleShowMore() {
		this.setState({
			expanded: !this.state.expanded,
		});
	}

	// Render Method
	render() {
		return (
			<Container class={`${style.timeSlotsCard}`}>
				<Row>
					{!this.props.condensedAdministrators && (
						<Col span={{sm: 24}} noPaddingTop>
							<Row class={style.administratorDetails}>
								{this.props.image ? (
									<Col class={style.administratorImage}>
										<SquareImage
											image={this.props.image}
											minWidth="64px"
											maxWidth="64px"
										/>
									</Col>
								)
								:<div className={style.defaultImage}>
									<img src={providerImage} alt="default Image"/>
								</div>
								}
								<Col class={style.administratorInfo}>
									<label class={style.cardName}>{this.name}</label>

									{
										this.props.description &&
										<div className={style.administratorDescription}>
											{ 
												this.props.description.split('\n').map((line, index) => (
													<p key={`${this.props.id}-description-${index}`}>{line}</p>
												))
											}
										</div>									
									}
								</Col>
							</Row>
						</Col>
					)}
					<Col span={{sm: 24}}>
						{this.waitListActivated && !this.hasRestrictions && (
							<Fragment>
								{this.showAddToQueue ? (
									<Row>
										<Col span={{ sm: 24}}>
											<div
												class={style.nextAvailable}
												onClick={this.destroyFromWaitlist.bind(
													null,
													this.waitlistItem.id
												)}
											>
												{<I18n>destroyMyWaitlist</I18n>}
											</div>
										</Col>
									</Row>
								) : (
									<Row>
										<Col span={{ sm: 24}}>
											<div
												class={style.nextAvailable}
												onClick={this.addToWaitlists}
											>
												<I18n>addedToWaitlist</I18n>
											</div>
										</Col>
									</Row>
								)}
							</Fragment>
						)}
						<Fragment>
							{ this.props.processing ? (
								<div class={style.spinnerOuter}>
									<LoadingIcon size={75}/>
								</div>
							) : (
								<Row class={[style.appointmentsContainer]}>
									<div className={style.appointContLabel}>
										<I18n>availability</I18n>
									</div>
									{this.timeSlots.map((timeSlots) => {
										return (
											<Col class={style.column}>
												<TimeSlotColumn
													isWidgetAvailableAfter={
														this.props.isWidgetAvailableAfter
													}
													timeSlots={timeSlots}
													onSelect={this.props.onSelect}
													selectedTimeSlot={this.props.selectedTimeSlot}
													showAll={this.state.expanded}
												/>
											</Col>
										);
									})}
								</Row>
							)}
							<div class={style.morePromptSpacer}>
								{!this.props.processing && this.moreTimeSlots ? (
									<div className={style.deployHours} onClick={this.handleShowMore}>
										<Row class={[style.centered, style.deployHoursLabel]}>
											<I18n>{this.state.expanded ? "showLessHours" : "showMoreHours"}</I18n>
										</Row>
										<Row class={[style.deployHoursIcon, (this.state.expanded ? style.rotate : "")]}>
											<img src={chevronDown} />
										</Row>
									</div>
								) : (
									""
								)}
								{!this.hasRestrictions &&
								!this.hasTimeSlots &&
								!this.props.condensedAdministrators &&
								!_.get(
									this,
									"props.organization.integrations.datapoint.active"
								) ? (
									<Row class={style.deployMessageOrButton}>
										<Col span={{ sm: 24 }}>
											<div
												class={`${style.nextAvailable} ${this.hasMoreAvailabilites ? style.nextAvailableButton : ""}`}
												onClick={
													this.hasMoreAvailabilites
														? this.props.handleSkipToNext
														: ""
												}
											>
												{this.hasMoreAvailabilites ? (
													<I18n>skipToAvailable</I18n>
												) : (
													<I18n>sorryNoFurtherAppointments</I18n>
												)}
											</div>
										</Col>
									</Row>
								) : (
									""
								)}
							</div>
						</Fragment>
					</Col>
				</Row>
			</Container>
		);
	}
}



// WEBPACK FOOTER //
// ./components/partials/TimeSlotsCard/index.js